module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteWarning":"Are you sure you want to delete this question?","yes":"Yes","no":"No"}}')
  delete Component.options._Ctor
}
